// import ModalForm from "./Form";
import StudyInformationTableForm from "./StudyInformationTableForm";
import {
	STUDY_INFORMATION_v2,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";

export const StudyInformationTableSchema = {
	components: { StudyInformationTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: STUDY_INFORMATION_v2 + "?invoice_id=" + this.invoiceRequestId,
			tableId: "study-information-table",
			formId: "study-information-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Class Name",
					type: "custom-html",
					key: "course",
					modifier: (value) => {
						return value.course_name;
					},
				},
                {
					title: "Mon",
					type: "custom-html",
					key: "course",
					modifier: (value) => value.day === 1 ? `${value.time_start} - ${value.time_end}` : "",
				},
                {
					title: "Tue",
					type: "custom-html",
					key: "course",
					modifier: (value) => value.day === 2 ? `${value.time_start} - ${value.time_end}` : "",
				},
                {
					title: "Wed",
					type: "custom-html",
					key: "course",
					modifier: (value) => value.day === 3 ? `${value.time_start} - ${value.time_end}` : "",
				},
                {
					title: "Thu",
					type: "custom-html",
					key: "course",
					modifier: (value) => value.day === 4 ? `${value.time_start} - ${value.time_end}` : "",
				},
                {
					title: "Fri",
					type: "custom-html",
					key: "course",
					modifier: (value) => value.day === 5 ? `${value.time_start} - ${value.time_end}` : "",
				},
                {
					title: "Sat",
					type: "custom-html",
					key: "course",
					modifier: (value) => value.day === 6 ? `${value.time_start} - ${value.time_end}` : "",
				},
				{
					title: "Sun",
					type: "custom-html",
					key: "course",
					modifier: (value) => value.day === 7 ? `${value.time_start} - ${value.time_end}` : "",
				},
                {
					title: "CLC Start Date",
					type: "custom-html",
					key: "course",
					modifier: (value) => {
						return value.course_date_clc_start;
					},
				},
				{
					title: "CLC End Date",
					type: "custom-html",
					key: "course",
					modifier: (value) => {
						return value.course_date_clc_end;
					},
				},
			],
			options: {
				name: "StudyInformationTable",
				url: STUDY_INFORMATION_v2 + "?invoice_id=" + this.invoiceRequestId,
				showHeader: true,
				enableHighlights: false,
				enableSaveFilter: false,
				enableRowSelect: false,
				columns: [],
				showFilter: false,
				showSearch: false,
				showCount: false,
				showClearFilter: false,
				paginationType: "false",
				responsive: true,
				rowLimit: 5,
				showAction: false,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
